import { Component, OnInit } from '@angular/core';
import { NavigateManagerService } from '../../../../../core/services/navigate-manager.service';
import { VehicleModelStateService } from '../../../../../core/services/impl/section-services/vehicle-model/vehicle-model-state.service';
import { VehicleModelState } from '../../../../states/vehicle-model.state';
import { VehicleDataModel } from '../../../../../core/models/vehicle-data.model';
import { OwnerDataStateService } from '../../../../../core/services/impl/section-services/owner-data/owner-data-state.service';
import { OwnerDataModel } from '../../../../../core/models/owner-data/owner-data.model';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import { isMPay, isSkycash } from '../../../../../core/utils/utils';
import {UrlParamsService} from '../../../../../core/services/impl/url-params.service';

@Component({
    selector: 'app-shortened-vehicle-data',
    templateUrl: './shortened-vehicle-data.component.html',
    styleUrls: ['./shortened-vehicle-data.component.scss']
})
export class ShortenedVehicleDataComponent implements OnInit {

    constructor(private vehicleModelStateService: VehicleModelStateService,
                private urlParamsService: UrlParamsService,
                private ownerDataStateService: OwnerDataStateService,
                private navigateManager: NavigateManagerService) {
    }

    get buttonLabel(): string {
        return ((isMPay() || isSkycash()) && this.urlParamsService.isMobileOrigin) ? 'SHORTENED-VEHICLE_COMPONENT.change' : 'SHORTENED-VEHICLE_COMPONENT.editData';
    }

    get vehicleData(): VehicleDataModel {
        return this.vehicleModelStateService.vehicleData;
    }

    get vehicleModelState(): VehicleModelState {
        return this.vehicleModelStateService.vehicleModelState;
    }

    get ownerData(): OwnerDataModel {
        return this.ownerDataStateService.ownerData;
    }

    get showRegistrationNumber(): boolean {
        return isNotNullOrUndefined(this.vehicleData.registrationNumber) && this.vehicleData.registrationNumber !== this.vehicleModelStateService.unknownRegistrationNumberValue;
    }

    ngOnInit() {
    }

    backToVehicleData() {
        this.navigateManager.moveToFirstStep();
    }
}
